import React, { useState } from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';

export function UsageButton({ children, onPress, active = false, toggle = false, disabled = false, icon, style, ...props }) {
  const { colors } = useTheme();
  const [focused, setFocused] = useState(false);
  return <Pressable accessibilityRole="button" accessibilityState={{ ...(toggle ? { selected: active } : {}), disabled }}
    {...(Platform.OS === 'web' && toggle ? { 'aria-pressed': active } : {})}
    onPress={onPress} disabled={disabled} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
    style={({ hovered, pressed }) => [styles.button, {
      opacity: disabled ? 0.5 : 1,
      backgroundColor: active || hovered || pressed ? colors.solid_color_secondary : 'transparent',
      borderColor: focused ? colors.text_color_primary : active ? colors.border_color_secondary : 'transparent',
    }, style]} {...props}>
    {!!icon && <Icon name={icon} size={13} color={colors.text_color_secondary} />}
    <Text size="s" weight={active ? 'semibold' : 'medium'} style={{ flexShrink: 1 }}>{children}</Text>
  </Pressable>;
}

export function UsageSegments({ label, options, value, onChange }) {
  const { colors } = useTheme();
  return <View accessibilityLabel={label} style={[styles.segments, { backgroundColor: colors.solid_color_secondary }]}>
    {options.map(option => <UsageButton key={option.value} toggle active={value === option.value}
      accessibilityLabel={option.accessibilityLabel || option.label} onPress={() => onChange(option.value)}
      style={[styles.segment, value === option.value && { backgroundColor: colors.solid_color_primary }]}>
      {option.label}
    </UsageButton>)}
  </View>;
}

const styles = StyleSheet.create({
  button: { minHeight: 44, paddingHorizontal: 12, paddingVertical: 9, borderRadius: 9, borderWidth: 1, flexDirection: 'row', gap: 8, alignItems: 'center', justifyContent: 'center' },
  segments: { flexDirection: 'row', padding: 3, borderRadius: 12, gap: 3, maxWidth: '100%' },
  segment: { flex: 1, paddingHorizontal: 10, minWidth: 0 },
});
